<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-label>Sage customer code</mat-label>
  <input
    formControlName="sageCustomerCode"
    type="text"
    matInput
    autocomplete="off"
    placeholder="e.g. VET004"
  >
  <mat-hint>{{ helper }}</mat-hint>
</mat-form-field>
